import React from 'react';
import ButtonAction from '../../../components/buttons/ButtonAction';
import { permissionObj } from '../../../Helpers/permission';
import SearchSimple from '../../../components/SearchSimples/SearchSimple';
import { CONTRACTORS_SUBVIEW_MODEL } from "../../Dashboard/Contractors/Model/Models";
import { USER_TYPE_MODEL } from "../../../enums/userTypeEnum";
import { PROVIDER_SUB_VIEW_MODEL } from "../../Provider/Model/Model";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: full stack
 */
const DocumentationHeader = ({
                                 subView,
                                 handleSubViewChange,
                                 searchElement,
                                 setSearchElement,
                                 permission,
                                 DEV,
                                 setSearchResults,
                                 searchResults,
                                 page,
                                 searchId,
                                 option,
                                 rowsPerPage,
                                 viewType,
                                 search,
                                 setSearch,
                                 setSimpleSearch,
                                 userTypeId
                             }) => {

    // The header is shared by contractors and suppliers, so each subview is gated with the
    // permission of the module being displayed and not with both of them
    const isContractor = userTypeId === USER_TYPE_MODEL.CONTRACTOR_IN_CHARGE;

    const canReadApprovalFlow = DEV || permission?.includes(isContractor
        ? permissionObj.WEB_CONTRACTOR_APPROVAL_FLOW_READ
        : permissionObj.WEB_SUPPLIER_APPROVAL_FLOW_READ);

    const canReadRequest = DEV || permission?.includes(isContractor
        ? permissionObj.WEB_CONTRACTOR_REQUEST_READ
        : permissionObj.WEB_SUPPLIER_REQUEST_READ);

    return (
        <div className='d-flex'>
            <div className='d-flex'>

                {/* approval_flow */}
                {canReadApprovalFlow && (
                    <ButtonAction
                        id='btn_dh_tab_approval_level'
                        name={'approval_flow'}
                        className={`mr-8px ${
                            subView === CONTRACTORS_SUBVIEW_MODEL.DOCUMENTATION.APPROVAL_FLOW ||
                            subView === PROVIDER_SUB_VIEW_MODEL.DOCUMENTATION.APPROVAL_FLOW
                                ? "btn-outlined-secondary-600-100"
                                : "btn-outlined-secondary-600-00"
                        }`}
                        disabled={false}
                        splitName={false}
                        onClick={() => {
                            if (userTypeId === USER_TYPE_MODEL.CONTRACTOR_IN_CHARGE) handleSubViewChange(CONTRACTORS_SUBVIEW_MODEL.DOCUMENTATION.APPROVAL_FLOW);
                            if (userTypeId === USER_TYPE_MODEL.SUPPLIER_IN_CHARGE) handleSubViewChange(PROVIDER_SUB_VIEW_MODEL.DOCUMENTATION.APPROVAL_FLOW);
                        }}
                    />
                )}

                {canReadRequest && (
                    <ButtonAction
                        id='btn_dh_tab_request'
                        name={'request'}
                        className={`mr-8px ${
                            subView === CONTRACTORS_SUBVIEW_MODEL.DOCUMENTATION.REQUESTS ||
                            subView === PROVIDER_SUB_VIEW_MODEL.DOCUMENTATION.REQUESTS
                                ? "btn-outlined-secondary-600-100"
                                : "btn-outlined-secondary-600-00"
                        }`}
                        disabled={false}
                        splitName={false}
                        onClick={() => {
                            if (userTypeId === USER_TYPE_MODEL.CONTRACTOR_IN_CHARGE) handleSubViewChange(CONTRACTORS_SUBVIEW_MODEL.DOCUMENTATION.REQUESTS);
                            if (userTypeId === USER_TYPE_MODEL.SUPPLIER_IN_CHARGE) handleSubViewChange(PROVIDER_SUB_VIEW_MODEL.DOCUMENTATION.REQUESTS);
                        }}
                    />
                )}

            </div>

            <div className='w-100'>
                <SearchSimple
                    page={page}
                    id={searchId}
                    optionTable={option}
                    rowsPerPage={rowsPerPage}
                    searchElement={searchElement}
                    setSearchElement={setSearchElement}
                    setSearchResults={setSearchResults}
                    searchResults={searchResults}
                    contractorId={null}
                    supplierId={null}
                    viewType={viewType}
                    search={search}
                    setSearch={setSearch}
                    setSimpleSearch={setSimpleSearch}
                    userTypeIds={[userTypeId]}
                />
            </div>
        </div>
    );
};

export default DocumentationHeader;
